import { cloneDeep } from "lodash";

export default function groups(state = {}, action) {
  const newState = { ...state };
  switch (action.type) {
    case "ADD_GROUP":
      newState[action.group.id] = action.group;
      newState[action.group.id].color = action.group.color || "green";
      newState[action.group.id].expanded = false;
      newState[action.group.id].numHabits = 0;
      newState[action.group.id].isGroup = true;
      return newState;
    case "EDIT_GROUP":
      newState[action.group.id] = {
        ...newState[action.group.id],
        ...action.group,
      };
      newState[action.group.id].isGroup = true;
      return newState;
    case "DELETE_GROUP":
      delete newState[action.groupId];
      return newState;
    case "FETCH_HABITS_SUCCESS":
      Object.keys(action.groupsHash).forEach((newGroupId) => {
        const group = action.groupsHash[newGroupId];
        newState[newGroupId] = {
          ...action.groupsHash[newGroupId],
          expanded: group.numHabits > 0 && state[newGroupId]?.expanded,
        };
      });
      return newState;
    case "TOGGLE_GROUP":
      // Create a new object for the group to ensure proper state updates
      if (state[action.groupId]?.numHabits === 0) return state;
      newState[action.groupId] = {
        ...newState[action.groupId],
        expanded: !newState[action.groupId].expanded,
      };

      return newState;
    case "CHANGE_HABIT_GROUP":
      if (action.from) {
        newState[action.from] = { ...newState[action.from] };
        newState[action.from].numHabits--;
        if (newState[action.from].numHabits === 0)
          newState[action.from].expanded = false;
      }
      if (action.to) {
        newState[action.to] = { ...newState[action.to] };
        newState[action.to].numHabits++;
      }
      return newState;
    case "UPDATE_GROUP_AFTER_REQUEST":
      newState[action.newGroup.id] = cloneDeep(newState[action.oldGroup.id]);
      delete newState[action.oldGroup.id];

      newState[action.newGroup.id].tmp = false;
      newState[action.newGroup.id].tmpId = action.oldGroup.id;
      newState[action.newGroup.id].id = action.newGroup.id;
      return newState;
    case "REMOVE_HABIT_FROM_GROUP":
      newState[action.groupId] = { ...newState[action.groupId] };
      newState[action.groupId].numHabits--;
      if (newState[action.groupId].numHabits === 0)
        newState[action.groupId].expanded = false;
      return newState;
    case "CLEAR_DATA":
      return {};
    case "INIT_STATE":
      return action.state.groupsEntities || {};
    default:
      return state;
  }
}
